"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var MuiDialogTitle = function MuiDialogTitle(_ref) {
  var toggleDialog = _ref.toggleDialog,
      rootClass = _ref.rootClass,
      text = _ref.text;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    disableTypography: true,
    className: styles.root
  }, text, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    "aria-label": "close",
    onClick: toggleDialog
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)));
};

var _default = MuiDialogTitle;
exports.default = _default;
MuiDialogTitle.propTypes = {
  text: _propTypes.default.string.isRequired,

  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** passed down from parent to close Dialog */
  toggleDialog: _propTypes.default.func.isRequired
};
MuiDialogTitle.defaultProps = {
  rootClass: []
};